import { useAdminPayments } from "./hooks/useAdminPaymentsPage";

import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Divider,
  InputAdornment,
  Stack,
  TextField,
} from "@mui/material";

import { FileDownload, Search } from "@mui/icons-material";
import DataTable from "react-data-table-component";
import { paymentColumns } from "./components/AdminPaymentsPage.columns";

export default function AdminPaymentsPage() {
  const { payments, loading, search, setSearch, handleExportCSV } =
    useAdminPayments();

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
        margin: "24px",
      }}
    >
      <CardHeader
        title="Registro de pagos"
        subheader="Visualiza todos los pagos y filtra resultados"
        action={
          <Button
            startIcon={<FileDownload />}
            variant="outlined"
            size="small"
            onClick={handleExportCSV}
          >
            Exportar CSV
          </Button>
        }
      />
      <Divider />

      <CardContent>
        <Stack spacing={2}>
          {/* BUSCADOR */}
          <TextField
            size="small"
            placeholder="Buscar por correo, estado o sesión de Stripe"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
          />

          {loading ? (
            <Stack alignItems="center" sx={{ py: 4 }}>
              <CircularProgress />
            </Stack>
          ) : (
            <DataTable
              columns={paymentColumns}
              data={payments}
              pagination
              highlightOnHover
              striped
              responsive
              persistTableHead
              pointerOnHover
              customStyles={{
                table: {
                  style: { width: "100%" },
                },
                headCells: {
                  style: {
                    fontWeight: "bold",
                    fontSize: "14px",
                  },
                },
              }}
            />
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}
